export const NEWS = {
    GET_NEWS: `http://newsapi.org/v2/top-headlines`,
};